export default "__VITE_ASSET__BbXh5gQI__"